module.exports = __webpack_public_path__ + "img/xcb-subject-item-11-2@2x.cdc82838.png";